import download from 'downloadjs';
import { UseToastOptions } from '@chakra-ui/toast/dist/types/use-toast';
import { AxiosResponse } from 'axios';

export const handleDownload = async (
  setIsLoadingDownload: (value: boolean) => void,
  downloadXls: (
    params: Record<string, string | number | boolean>,
  ) => Promise<AxiosResponse<Blob>>,
  toast: (options?: UseToastOptions) => string | number | undefined,
  params: Record<string, string | number | boolean>,
) => {
  setIsLoadingDownload(true);
  try {
    const r = await downloadXls(params);

    const filenameMatch =
      r.headers['content-disposition']?.match(/filename="(.+)"$/);
    const filename = filenameMatch?.[1] || 'arquivo.xlsx';

    download(new Blob([r.data], { type: r.data.type }), filename);
  } catch (err: any) {
    const text = await err?.response?.data?.text?.();
    let detail = 'Entre em contato para mais informações';

    try {
      const json = JSON.parse(text);
      detail = json?.detail || detail;
    } catch {
      detail = text || detail;
    }

    toast({
      title: 'Erro',
      description: detail,
      status: 'error',
      duration: 3000,
      isClosable: true,
      position: 'top-right',
    });
  } finally {
    setIsLoadingDownload(false);
  }
};
